<template>
  <div class="mood-change-desc">
    <div class="title-2">情绪变化描述</div>
    <transition-group
      v-if="dataSource.length"
      name="list"
      tag="div"
      class="desc-list"
      style="margin-top: 5px"
    >
      <div v-for="item in dataSource" :key="item.text" class="desc-list-item">
        {{ item.text }}
      </div>
    </transition-group>
    <EmptyData v-else :dataSource="dataSource" :loading="loading" />
  </div>
</template>

<script>
import moment from 'moment'
import { formatYearMonthDate } from '@/utils/date'
import { getAction } from '@api/manage'

// 0-学生 1-全校 2-年级 3-班级
const riseTextMap = {
  0: '近期情绪有所上升，建议持续对该学生进行关注。',
  1: '建议追溯学校近期发生的事件，总结上升原因，做好心理健康工作安排。',
  2: '建议年级主任多关注年级各班情绪异常时间，及时做好年级的情绪关怀工作',
  3: '请继续保持，平常多多关注情绪走势。',
}
const descendTextMap = {
  0: '近期该生情绪有所下降，建议持续对该学生进行关注。',
  1: '建议追溯学校近期发生的事件，重点关注情绪下降学生，及时做好心理辅导和干预工作。',
  2: '建议持续关注，督促相应的年级主任做好年级的情绪关怀工作。',
  3: '建议督促班主任多留意情绪低落学生，及时追溯原因，做好班级心理管理工作。',
}
// 0-学生 1-全校 2-年级 3-班级
//  动态字段
const typeFieldMapObj = {
  0: 'studentId',
  1: undefined,
  2: 'gradeId',
  3: 'classId',
}

export default {
  name: 'MoodChangeDesc',
  props: {
    dataRange: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dataSource: [],
      loading: false,
    }
  },
  methods: {
    // record参数记录， isClear是否清空记录
    async addItem(record, isClear = false) {
      // 清空记录
      if (isClear) {
        this.dataSource = []
      }
      // console.log('添加记录', record)
      const isHasRecord = this.dataSource.some((item) => item.name == record.name)
      if (isHasRecord) {
        this.$message.warn('该记录已添加过')
        return
      }

      const beginDate = formatYearMonthDate(this.dataRange[0])
      const endDate = formatYearMonthDate(this.dataRange[1])
      const days = moment(endDate).diff(beginDate, 'days')
      if (days < 3) {
        this.dataSource = [{ text: '筛选时间过短，无法进行分析描述' }]
        return
      }

      // 0-学生 1-全校 2-年级 3-班级，大于3的id，则不处理
      const idType = record.type
      if (idType == undefined || idType > 3) {
        return
      }

      const params = {
        beginDate,
        endDate,
      }

      if (idType != 1) {
        params[typeFieldMapObj[idType]] = record.id
      }
      this.loading = true
      const { success, result } = await getAction('/statistic/moodChangeDescription', params)
      this.loading = false
      if (!success) {
        this.$message.warn('暂无该记录')
        return
      }
      const { currentAvg, compareValue, currentMax, currentMin } = result
      const trendText = compareValue > 0 ? '上升' : '下降'
      const typeEndText = compareValue > 0 ? riseTextMap[idType] : descendTextMap[idType]
      const handleText = `${beginDate}至${endDate} ${
        record.name || '全校'
      }平均情绪指数 ${currentAvg}，对比往期${trendText} ${Math.abs(compareValue)}，
      其中${currentMax.date}日情绪值最高 ${currentMax.value}，
      ${currentMin.date}日情绪值最低 ${currentMin.value}，${typeEndText}`

      record.text = handleText
      this.dataSource.unshift(record)
    },
    deleteItem(name) {
      // 删除记录
      this.dataSource = this.dataSource.filter((item) => item.name != name)
    },
  },
}
</script>

<style scoped lang="less">
.mood-change-desc {
  max-height: 220px;
  overflow-y: auto;
  margin-top: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #e4e4e4;
  transition: height 0.3s ease;

  .desc-list {
    .desc-list-item {
      line-height: 2;
      color: #666;
      font-size: 14px;
      text-align: justify;
    }
  }
}

.list-enter-active {
  transition: all 0.4s ease;
}
.list-enter {
  opacity: 0;
  transform: translateY(-10px);
}
.list-leave-active {
  transition: all 0.3s ease;
}
.list-leave-to {
  opacity: 0;
}
</style>
